export const getMailTo = (to: string, subject = "", body = "") =>
	window.open(`mailto:${to}?subject=${subject}&body=${body}`)
